// Dependencies
import * as React from 'react';
// Styled
import { SvgElement } from './IconStyle';
// Props
import { IconProps, defaultProps } from './IconProps';

const Calendar = (props:IconProps) => {
  const componentProps = { ...defaultProps, ...props };
  const {
    backgroundColor,
    fillColor,
    height,
    onClick,
    width,
  } = componentProps;

  const handleClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
<SvgElement
      height={ height }
      onClick={ handleClick }
      preserveAspectRatio="none"
      viewBox="0 0 12 12"
      width={ width }
    >
      <g>
        <path
          fill={ fillColor }
          d="
						M11.5713482,2.5707858v8.5719109c0,0.2317648-0.0843801,0.4331522-0.2542658,0.6030378
						C11.1471968,11.9144945,10.9458094,12,10.7140446,12H
						1.2859554c-0.2328897,0-0.4331521-0.0855055-0.6030378-0.2542658
						c-0.1698856-0.1698856-0.2542659-0.371273-0.2542659-0.6030378V
						2.5707858c0-0.2317646,0.0843803-0.4320271,0.2542659-0.6019127
						s0.3701481-0.2542659,0.6030378-0.2542659H2.143259V1.071067c
						0-0.2947685,0.1046314-0.5467842,0.3138945-0.7560472
						C2.6675417,0.1046315,2.9195576,0,3.2143259,0h0.4286518C
						3.937746,0,4.1897616,0.1046315,4.399025,0.3150197
						C4.6094131,0.5242828,4.7140446,0.7762985,4.7140446,1.071067v0.6435401h2.5719109V1.071067
						c0-0.2947685,0.1046314-0.5467842,0.3150196-0.7560472C
						7.8102384,0.1046315,8.062254,0,8.3570223,0h0.4286518
						c0.2947683,0,0.5467844,0.1046315,0.7571726,0.3150197C
						9.7521095,0.5242828,9.856741,0.7762985,9.856741,1.071067v0.6435401
						h0.8573036c0.2317648,0,0.4331522,0.0843803,0.6030378,0.2542659S
						11.5713482,2.3390212,11.5713482,2.5707858z
						M1.2859554,6.2137632h1.9283705V4.2853928H1.2859554V6.2137632z M
						1.2859554,8.7856741h1.9283705V6.642415H1.2859554V8.7856741z
						M1.2859554,11.1426964h1.9283705V9.2143259H1.2859554V11.1426964
						z M3.856741,2.9994376V1.071067
						c0-0.0573786-0.0202513-0.1080068-0.0630038-0.1507595
						c-0.0427527-0.0416276-0.0933809-0.063004-0.1507595-0.063004H3.2143259
						c-0.0585036,0-0.1080067,0.0213764-0.1507595,0.063004
						c-0.0427527,0.0427527-0.063004,0.0933808-0.063004,0.1507595v1.9283706
						c0,0.0585036,0.0202513,0.1091318,0.063004,0.1507592c
						0.0427527,0.0427527,0.0922558,0.0641291,0.1507595,0.0641291h0.4286518
						c0.0573785,0,0.1080067-0.0213764,0.1507595-0.0641291C
						3.8364897,3.1085694,3.856741,3.0579412,3.856741,2.9994376z
						M3.6429777,6.2137632h2.143259V4.2853928h-2.143259V6.2137632z
						M3.6429777,8.7856741h2.143259V6.642415h-2.143259V8.7856741z
						M3.6429777,11.1426964h2.143259V9.2143259h-2.143259V11.1426964z
						M6.2137632,6.2137632h2.143259V4.2853928h-2.143259V6.2137632z
						M6.2137632,8.7856741h2.143259V6.642415h-2.143259V8.7856741z
						M6.2137632,11.1426964h2.143259V9.2143259h-2.143259V11.1426964z
						M8.9994373,2.9994376V1.071067c0-0.0573786-0.0202513-0.1080068-0.0630035-0.1507595
						c-0.0427532-0.0416276-0.0922556-0.063004-0.1507597-0.063004H8.3570223
						c-0.0585041,0-0.1080065,0.0213764-0.1507597,0.063004
						C8.1635103,0.9630602,8.143259,1.0136883,8.143259,1.071067v
						1.9283706c0,0.0585036,0.0202513,0.1091318,0.0630035,0.1507592
						c0.0427532,0.0427527,0.0922556,0.0641291,0.1507597,0.0641291h
						0.4286518c0.0585041,0,0.1080065-0.0213764,0.1507597-0.0641291
						C8.9791861,3.1085694,8.9994373,3.0579412,8.9994373,2.9994376z
						M8.7856741,6.2137632h1.9283705V4.2853928H8.7856741V6.2137632z
						M8.7856741,8.7856741h1.9283705V6.642415H8.7856741V8.7856741z
						M8.7856741,11.1426964h1.9283705V9.2143259H8.7856741V11.1426964z
					"
        />
      </g>
    </SvgElement>
  );
};

export { Calendar };
